export const GlobeBg = ({ className = "", opacity = 0.18 }) => (
  <svg viewBox="0 0 200 200" className={className} style={{ opacity }} fill="none" stroke="white" strokeWidth="1.2">
    <circle cx="100" cy="100" r="96" />
    <ellipse cx="100" cy="100" rx="40" ry="96" />
    <ellipse cx="100" cy="100" rx="72" ry="96" />
    <line x1="100" y1="4" x2="100" y2="196" />
    <path d="M10 70 Q100 55 190 70" /><path d="M4 100 H196" /><path d="M10 130 Q100 145 190 130" />
    <path d="M30 40 Q100 28 170 40" /><path d="M30 160 Q100 172 170 160" />
  </svg>
);

export const Orbit = ({ className = "", color = "white" }) => (
  <svg viewBox="0 0 400 120" className={className} fill="none">
    <path d="M10 92 C 90 10, 310 0, 392 40" stroke={color} strokeWidth="7" strokeLinecap="round" opacity="0.9" />
    <path d="M40 108 C 150 60, 300 58, 380 70" stroke={color} strokeWidth="3" strokeLinecap="round" opacity="0.5" />
  </svg>
);

export const Wordmark = ({ className = "", color = "#013B79" }) => (
  <div className={`flex items-center justify-center gap-2 font-black italic ${className}`} style={{ color }} dir="ltr">
    <span className="text-[0.8em] opacity-80">‹‹</span><span className="tracking-wide">A.O.T.C</span><span className="text-[0.8em] opacity-80">››</span>
  </div>
);
